import PropTypes from "prop-types"

import withHeader from "areas/header/hoc/with-header"
import Button from "components/ui/button"
import { cn } from "styles/utils"

const BurgerMenu = ({ showMenu, toggleMenu }) => {
  return (
    <Button
      aria-controls="mobile-menu"
      aria-expanded={showMenu}
      aria-haspopup="true"
      aria-label="Menu"
      className="desktop:ml-64 desktop:size-24 large:hidden ml-32 size-20 bg-white"
      data-cy="header-menu-icon-mobile"
      id="js_menu_toggle"
      onClick={() => toggleMenu(showMenu)}
      variant="text"
    >
      <div
        className={cn(
          "desktop:w-24 absolute block h-2 w-20 bg-black transition-all duration-200 ease-in-out",
          "desktop:before:w-24 before:absolute before:-top-7 before:block before:h-2 before:w-20 before:bg-black before:transition-all before:duration-200 before:ease-in-out",
          "desktop:after:w-24 after:absolute after:top-7 after:block after:h-2 after:w-20 after:bg-black after:transition-all after:duration-200 after:ease-in-out",
          showMenu &&
            "bg-transparent before:top-0 before:rotate-45 after:top-0 after:-rotate-45"
        )}
      />
    </Button>
  )
}

BurgerMenu.propTypes = {
  showMenu: PropTypes.bool,
  toggleMenu: PropTypes.func,
}

export default withHeader(BurgerMenu)
